<template>
  <div class="box-container">
    <div class="share-container">
      <share-url :url="`/event/${eventId}`"
        :title="`Check out this awesome event - ${title}`"/>
    </div>
    <router-link :to="`/event/${eventId}`">
      <div class="card">
        <img :src="pic" :alt="title">
        <div class="text-container">
          <div class="first-row">
            <div class="card-title">{{title}}</div>
            <div class="card-amount" v-if="minPricingPackage">
              <b>From {{minPricingPackage}}</b>
            </div>
          </div>
          <div class="card-date">
            {{new Date(startDate).toLocaleString('default', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}}
          </div>
          <div class="card-location">{{location}}</div>
          <div class="last-row">
            <div class="card-category">{{category}}</div>
            <!-- <div class="share">
              <font-awesome-icon :icon="['fa', 'share-alt']" size="sm" class="share-icon">
              </font-awesome-icon>
            </div> -->
          </div>
          <router-link class="card-owner-container" v-if="owner" :to="`/user/${owner.userName}`">
            <img v-if="owner.profilePic" :src="owner.profilePic" alt="Profile Picture"/>
            <font-awesome-icon v-else :icon="['fa', 'user-circle']" size="2x"
              :style="{ color: 'lightgray' }"/>
            <div class="card-owner-name">
              {{owner.displayName}}
            </div>
          </router-link>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'profile-events',
  computed: {
    owner() {
      if (this.team && this.team.length > 0) {
        return this.team[0].user;
      }
      return null;
    },
  },
  props: {
    eventId: {
      type: String,
      default: '',
    },
    pic: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    minPricingPackage: {
      type: String,
      default: '',
    },
    startDate: {
      type: Number,
      default: 0,
    },
    location: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    team: {
      type: Array,
      default: () => [],
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';


.box-container {
  margin: 0.5rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  border-radius: 10px;
  background-color: rgba(255,255,255,.98);
  position: relative;
  border: 1px solid #cccccc;
  &:hover {
    box-shadow: 0 1px 3px 3px rgba(0, 0, 0, 0.20);
  }
  & > a {
    text-decoration: none;
  }
}

.text-container {
  margin: 0 0.5rem;
}

.card-title {
  font-size: 1.15rem;
  color: #444444;
  text-align: left;
  &:hover {
    text-decoration: underline;
  }
}

.card-category, .card-location, .card-date {
  text-align: left;
  color: #656969;
  // &:hover {
  //   text-decoration: underline;
  // }
}

.card-location {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.last-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.first-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0 1rem 0;
  height: 2.5rem;
}

.card-amount {
  text-align: right;
  color: #1e1e1f;
}

.card img {
  width: 100%;
  border-radius: 10px 10px 0 0;
  align-items: center;
}

.share {
  font-size: 1rem;
  border-radius: 0.25rem;
  padding: 0.25rem;
  cursor: pointer;
}

.card-owner-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #333333;
  text-decoration: none;
  margin: 0.5rem 0;
  &:hover {
    text-decoration: underline;
  }
}

.card-owner-container > img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

.card-owner-name {
  margin-left: 0.5rem;
}

.share-container {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
}

</style>
